import { render, staticRenderFns } from "./PageTemplateIcon.vue?vue&type=template&id=6d0fc2a8"
import script from "./PageTemplateIcon.vue?vue&type=script&lang=js"
export * from "./PageTemplateIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports